import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'app/modules/common/services/shared-service';
import { LeaveService } from '../../../../leave/services/leave.service';
import { EmployeeService } from '../../../../employee/services/employee.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import * as  moment from 'moment';
import { ActuationService } from '../../../services/actuation.service';
import { ActuationOperation } from 'app/modules/common/enums/actuationOperation';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { NoFutureDateValidator } from 'app/modules/common/validation/common-validation';

@Component({
    selector: 'app-inform-medico',
    templateUrl: './inform-medico.component.html',
    styleUrls: ['./inform-medico.component.scss'],
    standalone: false
})
export class InformMedicoComponent implements OnInit {

  GestionFormGroup: UntypedFormGroup;
  ActuationOperation: number;
  leaveTypeInfo: string;
  leaveDate: string;
  leaveInfo: any;
  IsLoading = true;
  informeMedicoType: ActuationOperation = ActuationOperation.InformeMedico;

  constructor(
    public fb: UntypedFormBuilder,
    public router: Router,
    public snackBar: MatSnackBar,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public leaveService: LeaveService,
    public employeeService: EmployeeService,
    public actuationService: ActuationService,
    public employeeStoreService: EmployeeStoreService
  ) { }


  ngOnInit(): void {
    this.ActuationOperation = Number(this.route.snapshot.paramMap.get('operation'));
    const employeeId: number = Number(localStorage.getItem('EmplooyeeID'));
    this.getLeave()
      .subscribe(res => {
        this.getLeaveType(this.leaveInfo.tipo);
        this.employeeService.GetEmployeeForCreateVisit(employeeId)
          .subscribe(empResult => {
            this.actuationService.currentEmployee.next(empResult);
            this.InitForm();
            this.SetFormValues(empResult);
            this.IsLoading = false;
          }, error => {
            console.error(error);
          });
      }, err => {
        console.error(err);
      });
  }

  InitForm(): void {
    const today = moment();
    this.GestionFormGroup = this.fb.group({
      Employee: this.fb.group({
        EmployeeId: ['', Validators.required],
        LeaveId: ['', Validators.required]
      }),
      Gestion: this.fb.group({
        Type: [''],
        Date: [today, [
          this.GestionDateBetweenLeaveCommunicationAndTodayValidation(),
          NoFutureDateValidator()
        ]
        ],
        AutorInput: ['', Validators.required],
        OtherAutorInput: ['NONE', Validators.required],
        Autor: ['', Validators.required],
        TipoAutor: ['', Validators.required],
        Doctor: [''],
        Comments: ['']
      }),
      Document: this.fb.group({
        Type: [''],
        File: ['', Validators.required]
      })
    });
  }

  SetFormValues(res): void {
    this.GestionFormGroup.get(['Employee', 'EmployeeId']).setValue(res.result.employeeId);
    this.GestionFormGroup.get(['Employee', 'LeaveId']).setValue(this.leaveInfo.bajaId);
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup): void {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  CreateGestionConMutua(): void {
    this.markFormGroupTouched(this.GestionFormGroup);
    if (this.GestionFormGroup.valid) {
      const inputModel = this.GestionFormGroup.value;
      inputModel.Gestion.Date =
        (inputModel.Gestion.Date === null || !inputModel.Gestion.Date) ? null : DateHelper.getUTCDateString(DateHelper.getNativeDate(inputModel.Gestion.Date));
      this.actuationService.CreateInformeMedico(inputModel)
        .subscribe(res => {
          if (res.code === 0) {
            const snakBarRef = this.sharedService.ShowSnackBar("Actualizado exitosamente", "Okay", 2500);
            snakBarRef.afterDismissed().subscribe(_ => {
              this.router.navigateByUrl('/employee');
            });
          } else {
            this.sharedService.ShowSnackBar("Ocurrió un error", "Okay", 2500);
          }
        }, err => {
          console.error(err);
        });
    }
  }

  Cancel(): void {
    this.GestionFormGroup.reset();
    this.router.navigateByUrl('/employee');
  }

  getLeave(): Observable<any> {
    const id = this.route.snapshot.paramMap.get('id');
    return this.leaveService.GetLeaveById(id)
      .pipe(map(resp => resp.result), tap(result => {
        this.leaveInfo = result;
        this.leaveDate = DateHelper.getMomentDate(this.leaveInfo.fbaja).format("DD/MM/YYYY");
      }));
  }

  getLeaveType(leaveTipo: string): void {
    this.leaveService.GetLeaveType(leaveTipo)
      .subscribe(res => {
        this.leaveTypeInfo = res.result.label;
      }, err => {
        console.error(err);
      });
  }

  // Gestion
  private GestionDateBetweenLeaveCommunicationAndTodayValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!this.GestionFormGroup || !control.value) {
        return null;
      }
      if (!this.leaveInfo.avisoBaja) {
        return null;
      }
      const communicationDate: moment.Moment = DateHelper.getMomentDate(this.leaveInfo.avisoBaja);

      const forbidden = (control.value.isBefore(communicationDate) || control.value.isAfter(moment()));
      control.markAsTouched();
      return forbidden ? { 'GestionDateShouldBetweenCommunicationAndToday': { value: control.value } } : null;
    };
  }


}
